import axios from 'axios';
import {
  GET_AUTOMATION_FLOWS_BEGIN,
  GET_AUTOMATION_FLOWS_SUCCESS,
  GET_AUTOMATION_FLOWS_FAIL,

  CREATE_AUTOMATION_FLOW_BEGIN,
  CREATE_AUTOMATION_FLOW_SUCCESS,
  CREATE_AUTOMATION_FLOW_FAIL,

  UPDATE_AUTOMATION_FLOW_BEGIN,
  UPDATE_AUTOMATION_FLOW_SUCCESS,
  UPDATE_AUTOMATION_FLOW_FAIL,

  DELETE_AUTOMATION_FLOW_BEGIN,
  DELETE_AUTOMATION_FLOW_SUCCESS,
  DELETE_AUTOMATION_FLOW_FAIL,

  GET_AUTOMATION_LOGS_BEGIN,
  GET_AUTOMATION_LOGS_SUCCESS,
  GET_AUTOMATION_LOGS_FAIL,
} from './types';

export const getAutomationFlows = (params) => async (dispatch) => {
  dispatch({ type: GET_AUTOMATION_FLOWS_BEGIN });
  const url = process.env.REACT_APP_API_URL + '/private/automation/flows';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: GET_AUTOMATION_FLOWS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: GET_AUTOMATION_FLOWS_FAIL, errors: error });
    }

    return dispatch({ type: GET_AUTOMATION_FLOWS_FAIL });
  }
};

export const createAutomationFlow = (data) => async (dispatch) => {
  dispatch({ type: CREATE_AUTOMATION_FLOW_BEGIN });
  const url = process.env.REACT_APP_API_URL + '/private/automation/flows';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_AUTOMATION_FLOW_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_AUTOMATION_FLOW_FAIL, errors: error });
    }
    return dispatch({ type: CREATE_AUTOMATION_FLOW_FAIL });
  }
};

export const updateAutomationFlow = (params, flowID) => async (dispatch) => {
  dispatch({ type: UPDATE_AUTOMATION_FLOW_BEGIN });
  const url = process.env.REACT_APP_API_URL + '/private/automation/flows/' + flowID;
  try {
    const response = await axios.patch(url, { params });
    return dispatch({ type: UPDATE_AUTOMATION_FLOW_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: UPDATE_AUTOMATION_FLOW_FAIL, errors: error });
    }

    return dispatch({ type: UPDATE_AUTOMATION_FLOW_FAIL });
  }
};

export const deleteAutomationFlow = (flowID) => async (dispatch) => {
  dispatch({ type: DELETE_AUTOMATION_FLOW_BEGIN });
  const url = process.env.REACT_APP_API_URL + '/private/automation/flows/' + flowID;
  try {
    const response = await axios.delete(url);
    return dispatch({ type: DELETE_AUTOMATION_FLOW_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DELETE_AUTOMATION_FLOW_FAIL, errors: error });
    }

    return dispatch({ type: DELETE_AUTOMATION_FLOW_FAIL });
  }
};

export const getAutomationLogs = (params) => async (dispatch) => {
  dispatch({ type: GET_AUTOMATION_LOGS_BEGIN });
  const url = process.env.REACT_APP_API_URL + '/private/automation/flows/logs';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: GET_AUTOMATION_LOGS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: GET_AUTOMATION_LOGS_FAIL, errors: error });
    }

    return dispatch({ type: GET_AUTOMATION_LOGS_FAIL });
  }
};
